const TASK_CATEGORY_EXCLUSIONS_URL = '/api/taskCategories/exclusions';

export class TaskCategoryExclusionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCategories() {
    return this.#http.get(TASK_CATEGORY_EXCLUSIONS_URL);
  }

  async createCategory({ taskCategoryId }) {
    return this.#http.post(`${TASK_CATEGORY_EXCLUSIONS_URL}/${taskCategoryId}`);
  }

  async deleteCategory({ taskCategoryId }) {
    return this.#http.delete(`${TASK_CATEGORY_EXCLUSIONS_URL}/${taskCategoryId}`);
  }
}
